// src/components/Hero/Hero.jsx
import React, { useState, useEffect } from 'react';
import './hero.css';

// Import Desktop Images
import heroImg1 from '../../assets/hero1.png';
import heroImg2 from '../../assets/hero2.webp';
import heroImg3 from '../../assets/hero3.webp';

// Import Mobile Images
import heroMob1 from '../../assets/heromob1.png';
import heroMob2 from '../../assets/heromob2.png';
import heroMob3 from '../../assets/heromob3.png';

import { useNavigate } from 'react-router-dom';

const Hero = () => {
  const navigate = useNavigate();

  // State to track window width
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // Update state on resize
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Choose images based on screen size
  const desktopImages = [heroImg1, heroImg2, heroImg3];
  const mobileImages = [heroMob1, heroMob2, heroMob3];

  const images = isMobile ? mobileImages : desktopImages;

  const [currentImgIndex, setCurrentImgIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImgIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <section className={`hero-section ${isMobile ? '' : 'mx-5 mx-lg-4 rounded-5'}`}>

      {/* Background Images */}
      {images.map((img, index) => (
        <div
          key={index}
          className={`hero-bg-image ${index === currentImgIndex ? 'active' : ''}`}
          style={{ backgroundImage: `url(${img})` }}
        ></div>
      ))}

      {/* Overlay */}
      <div className="hero-overlay"></div>

      {/* Content */}
      <div className="hero-content text-start text-white">

        {/* Heading */}
        <h1 className="hero-heading mb-3">
          Building Quality Through <br />
          Industrial Innovation
        </h1>

        {/* Subheading */}
        <h5 className="hero-subheading mb-4">
          PRECISION METAL STAMPING & IN-HOUSE TOOLING EXCELLENCE
        </h5>

        {/* Description */}
        <p className="hero-description mb-4">
          DYNAMIC STAMPING PVT. LTD. IS AN ISO 9001:2015 & IATF 16949:2016 CERTIFIED AUTOMOTIVE COMPONENT MANUFACTURER, DELIVERING HIGH-PRECISION STAMPED PARTS, SUB-ASSEMBLIES & PLASTIC MOULDED COMPONENTS. SUPPORTED BY A FULLY EQUIPPED IN-HOUSE TOOL ROOM, ROBOTIC WELDING, AND ADVANCED MANUFACTURING FACILITIES.
        </p>

        {/* Trusted Partner Text */}
        <p className="hero-trusted-text mb-4">
          TRUSTED PARTNER TO OEMS & TIER-1 SUPPLIERS SINCE 2005
        </p>

        {/* Buttons Container */}
        <div className="hero-buttons-container justify-content-start">
          <button
            className="hero-btn-primary"
            onClick={() => navigate('/contact')}
          >
            Get A Quote
          </button>

          <button
            className="hero-btn-light"
            onClick={() => navigate('/capabilities')}
          >
            Explore Our Capabilities
          </button>
        </div>
      </div>

      {/* Dots (Desktop Only via CSS) */}
      <div className="dots-container">
        {images.map((_, index) => (
          <span
            key={index}
            className={`dot ${index === currentImgIndex ? 'active-dot' : ''}`}
            onClick={() => setCurrentImgIndex(index)}
          ></span>
        ))}
      </div>
    </section>
  );
};

export default Hero;